export default __webpack_public_path__ + "static/media/Bloodscythe Gauntlets.83ebb106.jpg";